import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Component, FormEvent } from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ILateFinalXmResponse, ReportActionCreators } from '@nkr/store/index';
import { ILateFinalXm } from '@nkr/models/index';
import { FormControl, Well } from 'react-bootstrap';
import Grid from './grid';
import { Utility } from '@nkr/services/utility';

interface IOwnProps {
    isCenterLogin: boolean,
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLateFinalXm: (centerId: number, startDate: string, endDate: string) => Promise<ILateFinalXmResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: ILateFinalXm[],
    recipientCenterId: number,
    startDate: string,
    endDate: string
}

class LateFinalXm extends Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        recipientCenterId: 0,
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD')
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(window.location.search);
        let startDate = moment().startOf('month').format('YYYY-MM-DD');
        let endDate = moment().endOf('month').format('YYYY-MM-DD');

        if (parsed.startDate != null) {
            startDate = parsed.startDate;
        }

        if (parsed.endDate != null) {
            endDate = parsed.endDate;
        }

        this.setState({
            startDate,
            endDate
        }, () => {
            this.props.showLoading('Getting late final XM records, one moment please...').then(() => {
                this.props.getLateFinalXm(this.props.centerId, this.state.startDate, this.state.endDate).then(response => {
                    this.setState({
                        data: response.data.results,
                    }, () => {
                        this.props.hideLoading();
                    });
                });
            });
        });
    }

    getFilteredData = () => {
        return this.state.data.filter(x => {
            let centerFilter = this.state.recipientCenterId > 0 ? x.recipientCenterId == this.state.recipientCenterId : true;
            return centerFilter;
        });
    }

    setUrl = () => {
        let newUrl = '/center/' + this.props.centerId + '/reports/my-center/late-final-xm?startDate=' + this.state.startDate + '&endDate=' + this.state.endDate;
        window.history.pushState({}, '', newUrl);
    }

    handleRecipientCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            recipientCenterId: parseInt(e.currentTarget.value)
        });
    }

    handleMonthChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        let selected = moment(e.currentTarget.value, 'YYYY-MM-DD');

        let startDate = selected.format('YYYY-MM-DD');
        let endDate = selected.endOf('month').format('YYYY-MM-DD');

        this.setState({
            startDate,
            endDate
        }, () => {
            this.props.showLoading('Getting late final XM records, one moment please...').then(() => {
                this.props.getLateFinalXm(this.props.centerId, this.state.startDate, this.state.endDate).then(response => {
                    this.setState({
                        data: response.data.results,
                    }, () => {
                        this.props.hideLoading();
                        this.setUrl();
                    });
                });
            });
        });
    }

    render = () => {
        const data = this.getFilteredData();

        const recipientCenterList = _.sortBy(_.uniqBy(this.state.data.map(item => {
            return { id: item.recipientCenterId, alias: item.recipientCenter };
        }), item => item.id), item => item.alias);

        const dateRange = Utility.getRange(moment().subtract(11, 'month'), moment().add(1, 'month'), 'month').map(x => x.startOf('month'));

        return (
            <>
                {this.props.isCenterLogin == false ?
                    <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Recipient Center:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.recipientCenterId}
                                        onChange={this.handleRecipientCenterChange}>
                                        <option value={0}>- All Centers -</option>
                                        {recipientCenterList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filter by Month:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.startDate}
                                        onChange={this.handleMonthChange}>
                                        {dateRange.map(date =>
                                            <option key={`ctr-${date.format('MM/DD/YYYY')}`} value={date.format('YYYY-MM-DD')}>{date.format('MM/YYYY')}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </Well>
                    :
                    <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4.5, paddingBottom: 4.5, marginBottom: 5 }}>
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filter by Month:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        bsSize='sm'
                                        value={this.state.startDate}
                                        onChange={this.handleMonthChange}>
                                        {dateRange.map(date =>
                                            <option key={`ctr-${date.format('MM/DD/YYYY')}`} value={date.format('YYYY-MM-DD')}>{date.format('MM/YYYY')}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </Well>
                }

                <Grid data={data} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLateFinalXm: (centerId, startDate, endDate) => {
            return dispatch(ReportActionCreators.getLateFinalXm(centerId, startDate, endDate));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(LateFinalXm);